import React from 'react';
import './resources.styles.scss';
import resourceScreenshot from '@/assets/resource-screenshot.png';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';

const ResourcesPage = () => {
  return (
    <UnauthLayout>
      <div className='resources-page'>
        <div className="g-space-1"></div>
        <div className='resources-card g-card'>
          <div className='section-title'>
            <div className='title'>Resource Center</div>
            <hr />
          </div>
          <div className='resources-content'>
            <div className='g-list-item'>
              <h3>What is Gamably?</h3>
              <div className='meta'>Video Overview</div>
              <p>This video gives a quick overview of Gamably's features and how to get started building your own custom game.</p>
              <iframe
                width="400"
                height="229"
                src="https://www.youtube.com/embed/e--KYQug3kM?si=I4LinrhSNI6fGPcr"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen>
              </iframe>
            </div>
            <div className='g-list-item'>
              <h3>How to Distribute Rewards</h3>
              <div className='meta'>Blog Post</div>
              <p>Check out our step-by-step guide to distributing rewards on the Gamably platform.</p>
              <a href="https://gamably.com/distribute-rewards-gamably/" target="_blank" rel="noopener noreferrer">
                <img src={resourceScreenshot} className='resource-screenshot' />
              </a>
            </div>
          </div>
        </div>
      </div>
    </UnauthLayout >

  )
}

export default ResourcesPage